/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Subunit
 */
export interface Subunit {
    /**
     * 
     * @type {string}
     * @memberof Subunit
     */
    text: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Subunit
     */
    publications: Array<string>;
}

/**
 * Check if a given object implements the Subunit interface.
 */
export function instanceOfSubunit(value: object): value is Subunit {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('publications' in value) || value['publications'] === undefined) return false;
    return true;
}

export function SubunitFromJSON(json: any): Subunit {
    return SubunitFromJSONTyped(json, false);
}

export function SubunitFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subunit {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'publications': json['publications'],
    };
}

export function SubunitToJSON(json: any): Subunit {
    return SubunitToJSONTyped(json, false);
}

export function SubunitToJSONTyped(value?: Subunit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'publications': value['publications'],
    };
}

